import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const ContentContainer = styled.div<{ $height: number }>`
  display: flex;
  flex-direction: column;
  height: ${({ $height }) => $height}px;
`

export const HeaderContainer = styled.div`
  padding: 0 0 16px 16px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.brand};
  width: auto;
  top: 10px;
  z-index: 2;
  background-color: #fff;
`

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: ${({ theme }) => theme.colors.darkText};
  text-align: left;
`

export const Description = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.darkText};
  margin-bottom: 8px;
  text-align: left;
`

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: auto;
`

export const LinkItem = styled(Link)`
  padding: 18px 36px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.darkText};
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.darkGrey || '#f5f5f5'};
    color: ${({ theme }) => theme.colors.brand};
    font-weight: 700;
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(149, 157, 165, 0.1);
  }
`
